<template>
  <div class="container-lg">
    <h1 class="page-header">Bifold door</h1>
    <div class="row">
      <div class="col-md-6 col-xl-4">
        <ValidationObserver v-slot="{ invalid }">
          <form @submit.prevent="handleSubmit()" name="form">
            <ValidationProvider
              name="Overall Width"
              rules="required"
              v-slot="{ errors }"
            >
              <div class="form-group row">
                <label class="col-6">Overall Width</label>
                <div class="col-6">
                  <div class="input-group">
                    <input
                      type="number"
                      class="form-control"
                      v-model.number="item.width"
                    />
                    <div class="input-group-text">mm</div>
                  </div>
                </div>
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              name="Overall Height"
              rules="required"
              v-slot="{ errors }"
            >
              <div class="form-group row">
                <label class="col-6">Overall Height</label>
                <div class="col-6">
                  <div class="input-group">
                    <input
                      type="number"
                      min="1600"
                      class="form-control"
                      v-model.number="item.height"
                    />
                    <div class="input-group-text">mm</div>
                  </div>
                </div>
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              name="Left hand doors"
              rules="required|min_value:0|max_value:7"
              v-slot="{ errors }"
            >
              <div class="form-group row">
                <label class="col-6">Left hand doors</label>
                <div class="col-6">
                  <input
                    type="number"
                    min="1"
                    max="7"
                    class="form-control"
                    v-model.number="item.lh_doors"
                  />
                </div>
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>
            <ValidationProvider
              name="Right hand doors"
              rules="required|min_value:0|max_value:7"
              v-slot="{ errors }"
            >
              <div class="form-group row">
                <label class="col-6">Right hand doors</label>
                <div class="col-6">
                  <input
                    type="number"
                    min="1"
                    max="7"
                    class="form-control"
                    v-model.number="item.rh_doors"
                  />
                </div>
                <span class="text-danger">{{ errors[0] }}</span>
              </div>
            </ValidationProvider>

            <h4 class="mb-4">Options</h4>

            <ValidationProvider
              name="Opening"
              rules="required"
              v-slot="{ errors }"
            >
              <div class="form-group row">
                <label class="col-4">Opening</label>
                <div class="col-8">
                  <select class="form-control" v-model="item.outward_opening">
                    <option :value="false">Inwards opening</option>
                    <option :value="true">Outwards opening</option>
                  </select>
                  <span class="text-danger">{{ errors[0] }}</span>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider
              name="Colour"
              rules="required"
              v-slot="{ errors }"
            >
              <div class="form-group row">
                <label class="col-4">Colour</label>
                <div class="col-8">
                  <select class="form-control" v-model="item.color">
                    <option v-for="(c, k) in colors" :value="k" :key="k">
                      {{ c }}
                    </option>
                  </select>
                  <span class="text-danger">{{ errors[0] }}</span>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              name="Cill"
              rules="required"
              v-slot="{ errors }"
            >
              <div class="form-group row">
                <label class="col-4">Cill size</label>
                <div class="col-8">
                  <select class="form-control" v-model.number="item.cill">
                    <option value="0">No cill</option>
                    <option value="90">90 mm</option>
                    <option value="150">150 mm</option>
                    <option value="190">190 mm</option>
                    <option value="230">230 mm</option>
                  </select>
                  <span class="text-danger">{{ errors[0] }}</span>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              name="Threshold"
              rules="required"
              v-slot="{ errors }"
            >
              <div class="form-group row">
                <label class="col-4">Threshold</label>
                <div class="col-8">
                  <select class="form-control" v-model="item.threshold">
                    <option value="s">Standard</option>
                    <option value="l">Low Threshold</option>
                    <option value="lr">Low with Rebate</option>
                  </select>
                  <span class="text-danger">{{ errors[0] }}</span>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              name="Adjustable jam"
              rules="required"
              v-slot="{ errors }"
            >
              <div class="form-group row">
                <label class="col-4">Jam</label>
                <div class="col-8">
                  <select class="form-control" v-model="item.add_jam">
                    <option :value="true">Adjustable jam</option>
                    <option :value="false">Fixed jam</option>
                  </select>
                  <span class="text-danger">{{ errors[0] }}</span>
                </div>
              </div>
            </ValidationProvider>

            <ValidationProvider
              name="Glass size"
              rules="required"
              v-slot="{ errors }"
            >
              <div class="form-group row">
                <label class="col-4">Glass size</label>
                <div class="col-8">
                  <select class="form-control" v-model="item.glass_size">
                    <option value="28">28 mm</option>
                    <option value="32">32 mm</option>
                    <option value="32">35 mm</option>
                    <option value="32">44 mm</option>
                  </select>
                  <span class="text-danger">{{ errors[0] }}</span>
                </div>
              </div>
            </ValidationProvider>

            <div class="form-group row">
              <div class="col-sm-12 text-right">
                <button
                  class="btn btn-light mr-4"
                  type="button"
                  @click="$router.back()"
                >
                  Cancel
                </button>
                <button
                  class="btn btn-primary"
                  type="submit"
                  :disabled="invalid"
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
      <div class="col-md-6 col-xl-8">
        <div v-html="svg" id="svg"></div>
      </div>

      <table class="table">
        <thead>
          <tr>
            <th>Qty</th>
            <th>SKU</th>
            <th>Part</th>
            <th>Name</th>
            <th>Cut size</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="bomerr">
            <td cols="5">
              <pre>
                {{ bomerr }}
              </pre>
            </td>
          </tr>
          <tr v-for="(item, index) in bom" :key="index">
            <td>{{ item.Qty }}</td>
            <td>{{ item.SKU }}</td>
            <td>{{ item.Part }}</td>
            <td>{{ item.Name }}</td>
            <td align="right">{{ item.CutSize }} mm</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { authFetch } from "../lib/auth.js";

export default {
  props: {
    id: String,
  },
  data() {
    return {
      item: {
        // Add fields here so vue watches all fields for changes
        id: null,
        width: 3000,
        height: 2100,
        lh_doors: 3,
        rh_doors: 1,
        outward_opening: true,
        color: "RAL7016",
        cill: 0,
        threshold: "s",
        add_jam: false,
        glass_size: 28,
      },
      colors: [],
      svg: null,
      bom: null,
      bomerr: null,
      previewTimer: null,
    };
  },
  computed: {},
  created() {
    this.load();
  },
  watch: {
    id() {
      this.load();
    },
    item: {
      handler() {
        if (this.previewTimer) {
          clearTimeout(this.previewTimer);
        }
        this.previewTimer = setTimeout(this.preview, 500);
      },
      deep: true,
    },
  },
  methods: {
    preview() {
      authFetch("/api/render", {
        method: "post",
        body: JSON.stringify(this.item),
      }).then((resp) => {
        resp.text().then((t) => {
          this.svg = t;
        });
      });
      authFetch("/api/bom", {
        method: "post",
        body: JSON.stringify(this.item),
      }).then((resp) => {
        if (resp.ok) {
          this.bomerr = null
          resp.json().then((j) => {
            this.bom = j;
          });
        } else {
          this.bom = null
          resp.text().then(t => this.bomerr = t)
        }
      });
    },
    handleSubmit() {
      if (this.item.id) {
        // Update existing
        authFetch("/api/bifold/" + this.item.id, {
          method: "put",
          body: JSON.stringify(this.item),
        }).then((resp) => {
          switch (resp.status) {
            case 200:
              this.$router.back();
              return;
            default:
              alert(resp.statusText);
          }
        });
      } else {
        // Add new
        authFetch("/db/bifold", {
          method: "post",
          body: JSON.stringify(this.item),
        }).then((resp) => {
          switch (resp.status) {
            case 200:
              resp.text().then((id) => {
                this.item.id = parseInt(id);
              });
              //   this.$router.back();
              return;
            default:
              alert(resp.statusText);
          }
        });
      }
    },
    load() {
      this.colors = {
        "RAL7016": "Anthracite 7016",
        "RAL9016": "White 9016",
        "RAL9005":"Black 9005",
        "MILL":"Mill Finish",
        "":"Anthracite Out & White In",
        "":"Black Out & White In",
        "":"White Out & Anthracite In",
      };
      if (!this.id) {
        this.previewTimer = setTimeout(this.preview, 500);
        return;
      } else {
        authFetch("/db/bifold/" + this.id)
          .then((resp) => resp.json())
          .then((data) => {
            this.item = data;
            this.previewTimer = setTimeout(this.preview, 500);
          });
      }
    },
  },
};
</script>

<style lang="scss">
#svg svg {
  width: 100%;
  height: auto;
}
</style>